export default __webpack_public_path__ + "static/media/side_view_woman_posing_ocean.09c3eca1.webp";